<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      Informacije o radu:
    </div>
    <table>
      <thead>
        <tr>
          <td colspan="2">Informacije:</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in dataToShow" :key="index">
          <td>
            {{ $t('competitions.works.' + item) }}
          </td>
          <td>
            {{ modalData[item] }}
          </td>
        </tr>
      </tbody>
    </table>
    {{ modalData.work }}
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'competitionWorkInfo',
  props: {
    modalData: {
      required: true
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      dataToShow: [
        'cmp_name',
        'wrk_name',
        'wrk_author',
        'wrk_email',
        'wrk_phone_number',
        'wrk_region',
        'wrk_postal_code',
        'wrk_address'
      ]
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      this.windowWidth = window.innerWidth
    },
    closeModal () {
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/tableStyles.scss';
table {
  border: none;

  td {
    border-bottom: none !important;
  }
  tbody tr:nth-child(odd) {
    background: rgba(196, 196, 196, 0.15);
  }
}
.modal-wrapper {
  width: 650px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import '@/assets/scss/scrollbarStyles.scss';
  @include scrollbar;

  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
}
.mobile-table {
  tbody tr {
    background: none !important;
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap;
  }
  tbody tr td {
    border-bottom: none;
    vertical-align: top;
    width: 50%;
    height: 100%;
    padding: 5px;
  }
  tr td:last-child {
    width: 100%;
  }
}
.bold-td-text {
  font-weight: 700;
  font-size: 17px;
}
.regular-td-text {
  font-weight: 500;
  font-size: 14px;
}
.light-grey {
  color: #9b9b9b;
  text-align: right;
  vertical-align: top;
  font-weight: 400;
  font-size: 13px;
}
.status-color {
  color: #8e3e4c;
  text-align: right;
  font-weight: 600;
  font-size: 13px;
}
</style>
